import React, { useState, useEffect } from "react";
import { Redirect, useParams, useHistory, useLocation, Link } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
//import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from "@material-ui/core/FormLabel";
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import Item from "../Components/Item/Item"; // scroll infinito
import CartPopup from "../Components/CartPopup";
import ProfileDati from "../Components/Profile/ProfileDati";
import ProfilePassword from "../Components/Profile/ProfilePassword";
import ProfileIndirizzi from "../Components/Profile/ProfileIndirizzi";
import ProfileOrderList from "../Components/Profile/ProfileOrderList";

function Profile(props) {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const [Section, setSection] = useState(
    params.section && params.section.length > 0 ? params.section : "dati"
  );

  // Allineamento dello stato a params quando si richiama una sezione specifica
  // da link esterni ma siamo già all'interno del componente
  useEffect(() => {
    setSection(params.section);
  }, [params]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [AddToCart, setAddToCart] = useState(false);
  const [DesktopMode, setDesktopMode] = useState(
    window.matchMedia(props.cfg.mediaClause).matches ? false : true
  );
  const [ShowMenu, setShowMenu] = useState(false);

  // rileva il passaggio in modalità desktop/mobile (e viceversa), causando il
  // rendering della slideshow in modalità differente
  useEffect(() => {
    const onResize = () => {
      let mode = window.matchMedia(props.cfg.mediaClause).matches
        ? false
        : true;
      //console.log("DesktopMode = "+mode)
      if (mode !== DesktopMode) setDesktopMode(mode);
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("scroll", onResize);
  }, [DesktopMode, props.cfg.mediaClause]);

  if (props.userData === null) {
    return <Redirect to="/login" />;
  }

  function addToCartHandler(productId, qty = 1) {
    let params = [
      { name: "session", value: props.sessionKey },
      {
        name: "id_utente",
        value: props.userData ? props.userData.id_e_user.toString() : "0",
      },
      { name: "id_e_products", value: productId.toString() },
      { name: "id_e_products_models", value: "0" },
      { name: "quantita_carrello", value: qty.toString() },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/carrello/add",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        props.cartUpd(respData.data);
        setAddToCart(true);
      }
    );
  }

  async function toggleWishlistHandler(productId, flag) {
    if (props.userData && props.userData.id_e_user.length > 0) {
      //console.log("CLICCATO PREFERITI!");
      let params = [
        {
          name: "id_e_user",
          value: props.userData ? props.userData.id_e_user.toString() : "0",
        },
        { name: "id_e_products", value: productId.toString() },
      ];
      props.wsCall(
        "https://ws.mediatoys.it/cliente/add_del_prodotto_preferiti",
        IsLoading,
        setIsLoading,
        netError,
        setNetError,
        params,
        (respData) => {
          //props.cartUpd(respData.data);
          //setAddToCart(true);
          props.setWishlist(respData);
          if (props.cfg.debug === true)
            console.log(respData);
        }
      );
    }
  }

  function closeCartDialog() {
    setAddToCart(false);
  }

  function selectMenu(section) {
    setSection(section);
    if (DesktopMode === false) {
      setShowMenu(false);
    }
  }

  const activeStyle = {
    fontWeight: "bold",
    //fontWeight: 900,
  };
  const inactiveStyle = {
    textDecoration: "none",
  };

  function menuHandler(sectionName) {
    //history.replace("/profilo/"+sectionName);
    history.push("/profilo/"+sectionName);
    selectMenu(sectionName);
  }

  const testlink = false;

  function manageMenu() {
    return (
      <>
        {testlink === true? (
        <div>
          <div>
            <Link to="/profilo/dati">Test dati</Link>
          </div>
          <div>
            <Link to="/profilo/preferiti">Test preferiti</Link>
          </div>
        </div>
        ) : null
        }
        <FormControl component="fieldset" onClick={() => menuHandler("dati")}>
          <FormLabel
            component="legend"
            style={Section === "dati" ? activeStyle : inactiveStyle}
          >
            Dati personali
          </FormLabel>
        </FormControl>
        <FormControl
          component="fieldset"
          onClick={() => menuHandler("password")}
        >
          <FormLabel
            component="legend"
            style={Section === "password" ? activeStyle : inactiveStyle}
          >
            Cambio password
          </FormLabel>
        </FormControl>
        <FormControl
          component="fieldset"
          onClick={() => menuHandler("indirizzi")}
        >
          <FormLabel
            component="legend"
            style={Section === "indirizzi" ? activeStyle : inactiveStyle}
          >
            Indirizzi spedizione
          </FormLabel>
        </FormControl>
        <FormControl component="fieldset" onClick={() => menuHandler("ordini")}>
          <FormLabel
            component="legend"
            style={Section === "ordini" ? activeStyle : inactiveStyle}
          >
            I miei ordini
          </FormLabel>
        </FormControl>
        <FormControl
          component="fieldset"
          onClick={() => menuHandler("preferiti")}
        >
          <FormLabel
            component="legend"
            style={Section === "preferiti" ? activeStyle : inactiveStyle}
          >
            I miei preferiti
          </FormLabel>
        </FormControl>
        <button className="utente_esci" onClick={props.logout}>
          Esci
        </button>
      </>
    );
  }
  /*
  function sectionOrderList() {
    return (
      <div className="form_login">
        <h2>Ordini</h2>
      </div>
    );
  }
*/
  function sectionWishList() {
    return (
      <div className="elenco_preferiti_utente">
        {props.wishlist !== null &&
        typeof props.wishlist.e_products_list !== "undefined"
          ? props.wishlist.e_products_list.map((item) => (
              <Item
                key={"it_" + item.id_e_products}
                item={item.detail[0]}
                urlImg={props.cfg.urlItemImg}
                click={addToCartHandler}
                toggle={toggleWishlistHandler}
                wishlist={props.wishlist}
                convert={props.cfg.convert}
                catalogSlug={props.cfg.catalogSlug}        
                //navClick={itemClickHandler}
              />
            ))
          : null}
      </div>
    );
  }

  function manageMobileMenuButton() {
    return (
      <div className="bordo_filtri">
        <div
          className="contenuto_filtri"
          onClick={() => setShowMenu(!ShowMenu)}
        >
          <div className="icona_filtri_utente">
            <img
              src="/images/menu_utente_on.svg"
              alt="Apri i menu"
              title="Apri i menu"
            />
          </div>
          <p>{ShowMenu === true ? "Chiudi il " : "Apri il "} Menu</p>
        </div>
        <div className="clear"></div>
      </div>
    );
  }

  return (
    <>
      <div className="contenitore_01">
        <div className="contenuto_01">
          <h1 className="titolo_pagina">Area utente</h1>
          {DesktopMode === false && IsLoading === false ? (
            <div className="filtri_mobile">{manageMobileMenuButton()}</div>
          ) : null}
          {DesktopMode === true || ShowMenu === true ? (
            <div className="barra-filtri barra-filtri_utente">
              {manageMenu()}
            </div>
          ) : null}
          <div className="contenitore_utente">
            {IsLoading === true || props.wishlist === null ? (
              <div className="spinner">
                <img src="/images/waiting.gif" alt="loading..." />
              </div>
            ) : // NOTA: avrebbe senso rendere tutte queste parti componenti
            Section === "dati" ? (
              <ProfileDati
                sessionKey={props.sessionKey}
                userData={props.userData}
                userUpdate={props.userUpdate}
                wsCall={props.wsCall}
                convert={props.cfg.convert}
              />
            ) : Section === "password" ? (
              <ProfilePassword
                sessionKey={props.sessionKey}
                userData={props.userData}
                wsCall={props.wsCall}
                cfg={props.cfg}
              />
            ) : Section === "indirizzi" ? (
              <ProfileIndirizzi
                sessionKey={props.sessionKey}
                userData={props.userData}
                wsCall={props.wsCall}
                cfg={props.cfg}
              />
            ) : Section === "ordini" ? (
              <ProfileOrderList
                token={props.token}
                userData={props.userData}
                wsCall={props.wsCall}
                convert={props.cfg.convert}
              />
            ) : Section === "preferiti" ? (
              sectionWishList()
            ) : (
              <ProfileDati
                sessionKey={props.sessionKey}
                userData={props.userData}
                userUpdate={props.userUpdate}
                wsCall={props.wsCall}
                convert={props.cfg.convert}
              />
            )}
            {AddToCart === true ? (
              <CartPopup
                titletext="Congratulazioni!"
                text="Articolo aggiunto al carrello"
                closeHandler={closeCartDialog}
              />
            ) : null}
          </div>
        </div>

        <div className="clear"></div>
      </div>
    </>
  );
}

export default Profile;
